import { ApiBase } from '@/api/api'
import { makeGetRequest } from '@/api/fetchCalls'
import type { DemographicsOption } from '@/types/integrations/demographics'

export async function getDemographicsOptions(): Promise<DemographicsOption[]> {
  return makeGetRequest(ApiBase + `/demographics/options`) as Promise<
    DemographicsOption[]
  >
}
